import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Avatar,
  Box,
  Button,
  getColor,
  Icons,
  Tabs,
  Tooltip,
  Typography,
} from "fds";
import "../index.scss";
import utilsCommon from "../../../shared/utils/common";
import { Workgroup } from "../../../types/workgroup";
import ClientFile from "./ClientFile";
import ClientMeeting from "./ClientMeeting";
import useWorkgroupStore from "../../../redux/dispatcher/useWorkgroupStore";
import { useParams } from "react-router-dom";
import { handleSetFavorite } from "../../../shared/utils/api";
import { t } from "i18next";
import dayjs from "dayjs";
import ClientHistory from "./ClientHistory";

const ClientWorkgorup = () => {
  const TAB_VALUES = [
    { key: "file", resource: t("common.file"), index: 0, hidden: false },
    {
      key: "meeting",
      resource: t("common.meetings"),
      index: 1,
      hidden: utilsCommon.checkMenuAvailable("zoom") === false,
    },
    { key: "log", resource: t("common.log"), index: 2, hidden: false },
  ];
  const { workgroupId } = useParams<{ workgroupId: string }>();
  const { workgroupState, getWorkgroupSideList, updateWorkgroupFavorite } =
    useWorkgroupStore();
  const [workgroupList, changeWorkgroupList] = useState<Workgroup[]>();
  const [tab, changeTab] = useState(0);
  const [focusedWorkgroupId, changeFocusedWorkgroupId] = useState<
    string | undefined
  >(undefined);
  const [refreshCnt, changeRefreshCnt] = useState(0);
  useEffect(() => {
    changeFocusedWorkgroupId(workgroupId);
    changeTab(0);
  }, [workgroupId]);
  useEffect(() => {
    let sorted_workgroup = workgroupState.workgroupSidemenuList
      .filter(
        (item: Workgroup) =>
          item.endDate === -1 || item.endDate > dayjs().valueOf()
      )
      .slice()
      .sort((a: Workgroup, b: Workgroup) => {
        if (a.favorite === "Y" && b.favorite !== "Y") return -1;
        if (a.favorite !== "Y" && b.favorite === "Y") return 1;
        return 0; // 원래 순서 유지
      });
    changeWorkgroupList(sorted_workgroup);
  }, [workgroupState.workgroupSidemenuList]);
  /** 워크그룹 웹으로 이동 */
  const handleMoveToWorkgroup = (workgroupId?: string) => {
    if (!workgroupId) return;
    if (utilsCommon.isClientLogin("MAC")) {
      (window as any)?.webkit?.messageHandlers.goWebWorkgroup.postMessage(
        workgroupId
      );
    } else if (utilsCommon.isClientLogin("WINDOWS")) {
      window?.chrome?.webview?.hostObjects.client.goWebWorkgroup(workgroupId);
    }
  };

  const handleRefreshClient = (workgroupId?: string) => {
    if (!workgroupId) return;
    getWorkgroupSideList({
      isDetail: "Y",
      managerId: "",
      orderBy: "workgroupName",
      orderByType: "ASC",
      pageRange: 1,
      posPage: 1,
      rowRange: 0,
      searchDate: { start: 0, end: 0 },
      status: 1,
      workgroupName: "",
    });
  };
  const renderClientHeader = (workgroup?: Workgroup) => {
    return (
      <Box height={88} classes="clientEco-header" alignItems="center">
        <Avatar
          name={workgroup?.workgroupName}
          uniqueCode={workgroup?.workgroupId ?? ""}
          shape="workgroup"
          size="48"
        />
        <Box
          direction="column"
          width={"calc(100% - 95px)"}
          classes="mg ml-12"
          justifyContent="center"
        >
          <Box height={32} alignItems="center">
            <Tooltip
              message={workgroup?.workgroupName}
              maxWidth={"calc(100% - 32*3px)"}
            >
              <Typography type="subtitle1" ellipsis>
                {workgroup?.workgroupName}
              </Typography>
            </Tooltip>
            <Tooltip
              message={
                workgroup?.favorite === "Y"
                  ? t("workgroup.unfavWorkgroup")
                  : t("workgroup.favWorkgroup")
              }
            >
              <Button
                btnStyle="icon"
                onClick={() =>
                  handleSetFavorite(
                    workgroup?.workgroupId,
                    updateWorkgroupFavorite,
                    workgroupList
                  )
                }
                leadingIcon={
                  workgroup?.favorite === "N" ? (
                    <Icons variant="line" label="star" isOn />
                  ) : (
                    <Icons variant="fill" label="star" isColored />
                  )
                }
              />
            </Tooltip>
            <Tooltip message={t("common.moveToWorkgroup")}>
              <Button
                btnStyle="icon"
                onClick={() => handleMoveToWorkgroup(workgroup?.workgroupId)}
                leadingIcon={<Icons variant="line" label="export" />}
              />
            </Tooltip>
          </Box>
          <Tooltip message={workgroup?.desc}>
            <Typography
              type="caption1_rg"
              ellipsis
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {workgroup?.desc}
            </Typography>
          </Tooltip>
        </Box>
      </Box>
    );
  };
  return (
    <Box direction="column" width={"calc(100% - 64px)"}>
      {renderClientHeader(
        workgroupList?.filter(
          (item) => item.workgroupId === focusedWorkgroupId
        )[0]
      )}
      <Box classes="clientEco-tabs">
        <Tabs
          type={"leftFull"}
          selected={tab}
          textAlign={"left"}
          selectTab={(newTab) => changeTab(newTab)}
          tabs={TAB_VALUES.map((item) => {
            return {
              text: item.resource,
              color: "default",
              isNew: false,
              isHidden: item.hidden,
            };
          })}
          paddingLeft={20}
          size={"lg"}
        />
        <Tooltip message={t("common.refresh")} classes="mg ml-auto mr-16">
          <Button
            btnStyle="icon"
            classes="mg ml-auto"
            onClick={() => window.location.reload()}
            leadingIcon={<Icons variant="line" label="refresh" />}
          />
        </Tooltip>
      </Box>
      {!focusedWorkgroupId ? (
        <></>
      ) : tab === 0 ? (
        <ClientFile workgroupId={focusedWorkgroupId} refreshCnt={refreshCnt} />
      ) : tab === 1 ? (
        <ClientMeeting
          workgroupId={focusedWorkgroupId}
          refreshCnt={refreshCnt}
        />
      ) : (
        <ClientHistory
          workgroupId={focusedWorkgroupId}
          refreshCnt={refreshCnt}
        />
      )}
    </Box>
  );
};

export default ClientWorkgorup;
